import React from 'react'
import { Link } from 'react-router-dom'
import StarIcon from '@mui/icons-material/Star'
import StarBorderIcon from '@mui/icons-material/StarBorder'
import { MotionButton, MotionCard, MotionImage, MotionSection } from '../motion/Motion'
import { getAllProducts, type Product } from '../../data/products'

function StarRating({ rating, reviewCount }: { rating: number; reviewCount: number }) {
  const full = Math.floor(rating)
  const empty = 5 - full
  return (
    <div className="flex items-center gap-0.5">
      {Array.from({ length: full }, (_, i) => (
        <StarIcon key={`f-${i}`} sx={{ fontSize: 16 }} className="text-amber-500" />
      ))}
      {Array.from({ length: empty }, (_, i) => (
        <StarBorderIcon key={`e-${i}`} sx={{ fontSize: 16 }} className="text-amber-500" />
      ))}
      <span className="ml-1 text-sm text-gray-500">({reviewCount})</span>
    </div>
  )
}

export default function BestSellingProducts() {
  const products = getAllProducts()

  return (
    <MotionSection className="w-[96%] mx-auto py-12 px-4 sm:px-6 md:px-8 lg:px-[40px]">
      <div className="flex flex-row items-baseline justify-between gap-2 mb-6">
        <h2 className="text-lg sm:text-2xl font-bold text-gray-900 ml-0 sm:ml-[10px] md:ml-[20px] lg:ml-[30px]">Best Selling Products</h2>
        <Link
          to="/products"
          className="rounded-full bg-pink-500 px-4 sm:px-5 py-2 text-sm font-semibold text-white shadow hover:bg-pink-600 transition-colors mr-0 sm:mr-[10px] md:mr-[16px] lg:mr-[20px] whitespace-nowrap"
        >
          <MotionButton>View All</MotionButton>
        </Link>
      </div>

      <div className="grid grid-cols-2 sm:grid-cols-3 lg:grid-cols-4 gap-x-[10px] gap-y-[20px]">
        {products.map((product: Product, index: number) => (
          <Link
            key={product.id}
            to={`/product/${product.slug}`}
            className="block"
          >
            <MotionCard 
              className="flex flex-col cursor-pointer h-full border-0 shadow-none" 
              delay={0.03 * index}
            >
              <div className="w-full flex-1 flex items-center justify-center bg-[#F6F6F6]">
                <MotionImage className="w-full flex items-center justify-center">
                  <img
                    src={encodeURI(product.image)}
                    alt={product.title}
                    className="w-full h-[200px] sm:h-[240px] md:h-[280px] lg:h-[320px] object-contain"
                  />
                </MotionImage>
              </div>
              <div className="mt-2 px-2 text-left">
                <h3 className="text-xs sm:text-sm font-bold text-gray-900 uppercase leading-tight line-clamp-2">
                  {product.title}
                </h3>
                <p className="mt-1.5 text-base font-bold text-orange-500">
                  {product.price ?? product.priceRange}
                </p>
                {product.rating != null && product.reviewCount != null && (
                  <div className="mt-1">
                    <StarRating rating={product.rating} reviewCount={product.reviewCount} />
                  </div>
                )}
              </div>
            </MotionCard>
          </Link>
        ))}
      </div>
    </MotionSection>
  )
}
